// Keyboard activation for elements that are interactive in practice but not in
// HTML — the dropdown options rendered as `<li onclick>` and the JS-action links
// rendered as `<a onclick>` without href.

/**
 * Wraps a click handler so Enter and Space activate the element too, which is
 * what a native button does.
 *
 * @param {(event: Event) => void} handler the same handler passed to onclick
 * @returns {(event: KeyboardEvent) => void}
 *
 * @example
 * <li role="option" tabindex="0"
 *     onclick={_select.bind(null, value)}
 *     onkeydown={activateOnKey(_select.bind(null, value))}>
 */
export const activateOnKey = (handler) => (event) => {
    // ' ' is Space. Any other key (Tab, arrows, Escape) must keep its behaviour.
    if (event.key !== 'Enter' && event.key !== ' ') {
        return;
    }

    // Space would scroll the page, Enter would submit a surrounding form.
    event.preventDefault();

    handler(event);
};
